/**
 * Chat Utility Functions
 *
 * Utilities for generating chat room IDs, QR code URLs, etc.
 */

/**
 * Generate a unique chat room ID
 * @returns {string} A unique chat room ID
 */
export const generateChatRoomId = () => {
  return `chat_${Date.now()}${Math.random().toString(36).substring(2, 9)}`;
};

/**
 * Extract chat room ID from URL
 * @param {string} url - The URL containing the chat room ID
 * @returns {string|null} The extracted chat room ID or null if not found
 */
export const extractChatRoomId = (url) => {
  // Check if URL contains /chat/ path
  if (url.includes('/chat/')) {
    // Split URL by /chat/ and get the part after it
    const parts = url.split('/chat/');
    if (parts.length > 1) {
      // Remove any trailing slash or query parameters
      return parts[1].split('/')[0].split('?')[0];
    }
  }
  return null;
};

// vCard functions have been removed to prevent automatic contact detection on mobile devices
// If needed in the future, they will be reimplemented in a controlled way
